import React, { Component } from 'react';
import { connect, Provider } from 'react-redux';
import PropTypes from 'prop-types';
import { applyRouterMiddleware, Router } from 'react-router';
import { useScroll } from 'react-router-scroll';

import { AriaLiveRoot } from 'components/common/AriaLive';
import { searchByTerm } from 'actions/headerfooter';
import { setupHolmes } from 'actions/holmes';
import { routeUpdateComplete } from 'actions/pageView';
import marketplace from 'cfg/marketplace.json';
import shouldScrollToTopFactory from 'helpers/shouldScrollToTop';

const identityTestGenerator = id => id;
const nullTestGenerator = () => null;
const scrollToTopDecider = shouldScrollToTopFactory(marketplace.features.pageTransitionScrollTarget);

export class Root extends Component {
  getChildContext() {
    return {
      testId: this.getTestId(),
      marketplace
    };
  }

  componentDidMount() {
    this.props.setupHolmes();
  }

  onUpdate = () => {
    this.props.store.dispatch(routeUpdateComplete());
  }

  getTestId = () => {
    const { renderTestLocators } = this.props;
    return renderTestLocators ? identityTestGenerator : nullTestGenerator;
  }

  render() {
    const { store, history, routes, canUseScroll, renderProps, onEnter } = this.props;
    const routerProps = { history };
    if (canUseScroll) {
      routerProps.render = applyRouterMiddleware(useScroll(scrollToTopDecider));
    }

    return (
      <>
        <Provider key={Math.random()} store={store}>
          <Router
            {...renderProps}
            {...routerProps}
            onUpdate={this.onUpdate}
            onEnter={onEnter}>
            {routes}
          </Router>
        </Provider>
        <AriaLiveRoot />
      </>
    );
  }
}

Root.propTypes = {
  history: PropTypes.object.isRequired,
  routes: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object
  ]).isRequired,
  store: PropTypes.object.isRequired
};

Root.defaultProps = {
  onEnter: () => null
};

Root.childContextTypes = {
  testId: PropTypes.func,
  marketplace: PropTypes.object
};

function mapStateToProps(state) {
  const renderTestLocators = 'renderTestLocators' in state.cookies;
  return {
    renderTestLocators,
    searchByTerm
  };
}

export default connect(mapStateToProps, {
  setupHolmes
})(Root);
